export interface Country {
  code: string; // ISO 3166-1 alpha-2 code
  en: string; // English name
  de: string; // German name
  tr: string; // Turkish name
}

export const COUNTRIES: Country[] = [
  { code: 'AF', en: 'Afghanistan', de: 'Afghanistan', tr: 'Afganistan' },
  { code: 'AL', en: 'Albania', de: 'Albanien', tr: 'Arnavutluk' },
  { code: 'DZ', en: 'Algeria', de: 'Algerien', tr: 'Cezayir' },
  { code: 'AD', en: 'Andorra', de: 'Andorra', tr: 'Andorra' },
  { code: 'AO', en: 'Angola', de: 'Angola', tr: 'Angola' },
  { code: 'AG', en: 'Antigua and Barbuda', de: 'Antigua und Barbuda', tr: 'Antigua ve Barbuda' },
  { code: 'AR', en: 'Argentina', de: 'Argentinien', tr: 'Arjantin' },
  { code: 'AM', en: 'Armenia', de: 'Armenien', tr: 'Ermenistan' },
  { code: 'AU', en: 'Australia', de: 'Australien', tr: 'Avustralya' },
  { code: 'AT', en: 'Austria', de: 'Österreich', tr: 'Avusturya' },
  { code: 'AZ', en: 'Azerbaijan', de: 'Aserbaidschan', tr: 'Azerbaycan' },
  { code: 'BS', en: 'Bahamas', de: 'Bahamas', tr: 'Bahamalar' },
  { code: 'BH', en: 'Bahrain', de: 'Bahrain', tr: 'Bahreyn' },
  { code: 'BD', en: 'Bangladesh', de: 'Bangladesch', tr: 'Bangladeş' },
  { code: 'BB', en: 'Barbados', de: 'Barbados', tr: 'Barbados' },
  { code: 'BY', en: 'Belarus', de: 'Weißrussland', tr: 'Belarus' },
  { code: 'BE', en: 'Belgium', de: 'Belgien', tr: 'Belçika' },
  { code: 'BZ', en: 'Belize', de: 'Belize', tr: 'Belize' },
  { code: 'BJ', en: 'Benin', de: 'Benin', tr: 'Benin' },
  { code: 'BT', en: 'Bhutan', de: 'Bhutan', tr: 'Butan' },
  { code: 'BO', en: 'Bolivia', de: 'Bolivien', tr: 'Bolivya' },
  { code: 'BA', en: 'Bosnia and Herzegovina', de: 'Bosnien und Herzegowina', tr: 'Bosna ve Hersek' },
  { code: 'BW', en: 'Botswana', de: 'Botswana', tr: 'Botsvana' },
  { code: 'BR', en: 'Brazil', de: 'Brasilien', tr: 'Brezilya' },
  { code: 'BN', en: 'Brunei', de: 'Brunei', tr: 'Brunei' },
  { code: 'BG', en: 'Bulgaria', de: 'Bulgarien', tr: 'Bulgaristan' },
  { code: 'BF', en: 'Burkina Faso', de: 'Burkina Faso', tr: 'Burkina Faso' },
  { code: 'BI', en: 'Burundi', de: 'Burundi', tr: 'Burundi' },
  { code: 'CV', en: 'Cabo Verde', de: 'Kap Verde', tr: 'Yeşil Burun Adaları' },
  { code: 'KH', en: 'Cambodia', de: 'Kambodscha', tr: 'Kamboçya' },
  { code: 'CM', en: 'Cameroon', de: 'Kamerun', tr: 'Kamerun' },
  { code: 'CA', en: 'Canada', de: 'Kanada', tr: 'Kanada' },
  { code: 'CF', en: 'Central African Republic', de: 'Zentralafrikanische Republik', tr: 'Orta Afrika Cumhuriyeti' },
  { code: 'TD', en: 'Chad', de: 'Tschad', tr: 'Çad' },
  { code: 'CL', en: 'Chile', de: 'Chile', tr: 'Şili' },
  { code: 'CN', en: 'China', de: 'China', tr: 'Çin' },
  { code: 'CO', en: 'Colombia', de: 'Kolumbien', tr: 'Kolombiya' },
  { code: 'KM', en: 'Comoros', de: 'Komoren', tr: 'Komorlar' },
  { code: 'CG', en: 'Congo', de: 'Kongo', tr: 'Kongo' },
  { code: 'CD', en: 'Congo, Democratic Republic of the', de: 'Kongo, Demokratische Republik', tr: 'Kongo Demokratik Cumhuriyeti' },
  { code: 'CR', en: 'Costa Rica', de: 'Costa Rica', tr: 'Kosta Rika' },
  { code: 'CI', en: 'Côte d\'Ivoire', de: 'Elfenbeinküste', tr: 'Fildişi Sahili' },
  { code: 'HR', en: 'Croatia', de: 'Kroatien', tr: 'Hırvatistan' },
  { code: 'CU', en: 'Cuba', de: 'Kuba', tr: 'Küba' },
  { code: 'CY', en: 'Cyprus', de: 'Zypern', tr: 'Kıbrıs' },
  { code: 'CZ', en: 'Czech Republic', de: 'Tschechische Republik', tr: 'Çek Cumhuriyeti' },
  { code: 'DK', en: 'Denmark', de: 'Dänemark', tr: 'Danimarka' },
  { code: 'DJ', en: 'Djibouti', de: 'Dschibuti', tr: 'Cibuti' },
  { code: 'DM', en: 'Dominica', de: 'Dominica', tr: 'Dominika' },
  { code: 'DO', en: 'Dominican Republic', de: 'Dominikanische Republik', tr: 'Dominik Cumhuriyeti' },
  { code: 'EC', en: 'Ecuador', de: 'Ecuador', tr: 'Ekvador' },
  { code: 'EG', en: 'Egypt', de: 'Ägypten', tr: 'Mısır' },
  { code: 'SV', en: 'El Salvador', de: 'El Salvador', tr: 'El Salvador' },
  { code: 'GQ', en: 'Equatorial Guinea', de: 'Äquatorialguinea', tr: 'Ekvator Ginesi' },
  { code: 'ER', en: 'Eritrea', de: 'Eritrea', tr: 'Eritre' },
  { code: 'EE', en: 'Estonia', de: 'Estland', tr: 'Estonya' },
  { code: 'SZ', en: 'Eswatini', de: 'Eswatini', tr: 'Esvati' },
  { code: 'ET', en: 'Ethiopia', de: 'Äthiopien', tr: 'Etiyopya' },
  { code: 'FJ', en: 'Fiji', de: 'Fidschi', tr: 'Fiji' },
  { code: 'FI', en: 'Finland', de: 'Finnland', tr: 'Finlandiya' },
  { code: 'FR', en: 'France', de: 'Frankreich', tr: 'Fransa' },
  { code: 'GA', en: 'Gabon', de: 'Gabun', tr: 'Gabon' },
  { code: 'GM', en: 'Gambia', de: 'Gambia', tr: 'Gambiya' },
  { code: 'GE', en: 'Georgia', de: 'Georgien', tr: 'Gürcistan' },
  { code: 'DE', en: 'Germany', de: 'Deutschland', tr: 'Almanya' },
  { code: 'GH', en: 'Ghana', de: 'Ghana', tr: 'Gana' },
  { code: 'GR', en: 'Greece', de: 'Griechenland', tr: 'Yunanistan' },
  { code: 'GD', en: 'Grenada', de: 'Grenada', tr: 'Grenada' },
  { code: 'GT', en: 'Guatemala', de: 'Guatemala', tr: 'Guatemala' },
  { code: 'GN', en: 'Guinea', de: 'Guinea', tr: 'Gine' },
  { code: 'GW', en: 'Guinea-Bissau', de: 'Guinea-Bissau', tr: 'Gine-Bissau' },
  { code: 'GY', en: 'Guyana', de: 'Guyana', tr: 'Guyana' },
  { code: 'HT', en: 'Haiti', de: 'Haiti', tr: 'Haiti' },
  { code: 'HN', en: 'Honduras', de: 'Honduras', tr: 'Honduras' },
  { code: 'HU', en: 'Hungary', de: 'Ungarn', tr: 'Macaristan' },
  { code: 'IS', en: 'Iceland', de: 'Island', tr: 'İzlanda' },
  { code: 'IN', en: 'India', de: 'Indien', tr: 'Hindistan' },
  { code: 'ID', en: 'Indonesia', de: 'Indonesien', tr: 'Endonezya' },
  { code: 'IR', en: 'Iran', de: 'Iran', tr: 'İran' },
  { code: 'IQ', en: 'Iraq', de: 'Irak', tr: 'Irak' },
  { code: 'IE', en: 'Ireland', de: 'Irland', tr: 'İrlanda' },
  { code: 'IL', en: 'Israel', de: 'Israel', tr: 'İsrail' },
  { code: 'IT', en: 'Italy', de: 'Italien', tr: 'İtalya' },
  { code: 'JM', en: 'Jamaica', de: 'Jamaika', tr: 'Jamaika' },
  { code: 'JP', en: 'Japan', de: 'Japan', tr: 'Japonya' },
  { code: 'JO', en: 'Jordan', de: 'Jordanien', tr: 'Ürdün' },
  { code: 'KZ', en: 'Kazakhstan', de: 'Kasachstan', tr: 'Kazakistan' },
  { code: 'KE', en: 'Kenya', de: 'Kenia', tr: 'Kenya' },
  { code: 'KI', en: 'Kiribati', de: 'Kiribati', tr: 'Kiribati' },
  { code: 'KP', en: 'Korea, North', de: 'Korea, Nord', tr: 'Kuzey Kore' },
  { code: 'KR', en: 'Korea, South', de: 'Korea, Süd', tr: 'Güney Kore' },
  { code: 'KW', en: 'Kuwait', de: 'Kuwait', tr: 'Kuveyt' },
  { code: 'KG', en: 'Kyrgyzstan', de: 'Kirgisistan', tr: 'Kırgızistan' },
  { code: 'LA', en: 'Laos', de: 'Laos', tr: 'Laos' },
  { code: 'LV', en: 'Latvia', de: 'Lettland', tr: 'Letonya' },
  { code: 'LB', en: 'Lebanon', de: 'Libanon', tr: 'Lübnan' },
  { code: 'LS', en: 'Lesotho', de: 'Lesotho', tr: 'Lesotho' },
  { code: 'LR', en: 'Liberia', de: 'Liberia', tr: 'Liberya' },
  { code: 'LY', en: 'Libya', de: 'Libyen', tr: 'Libya' },
  { code: 'LI', en: 'Liechtenstein', de: 'Liechtenstein', tr: 'Liechtenstein' },
  { code: 'LT', en: 'Lithuania', de: 'Litauen', tr: 'Litvanya' },
  { code: 'LU', en: 'Luxembourg', de: 'Luxemburg', tr: 'Lüksemburg' },
  { code: 'MG', en: 'Madagascar', de: 'Madagaskar', tr: 'Madagaskar' },
  { code: 'MW', en: 'Malawi', de: 'Malawi', tr: 'Malavi' },
  { code: 'MY', en: 'Malaysia', de: 'Malaysia', tr: 'Malezya' },
  { code: 'MV', en: 'Maldives', de: 'Malediven', tr: 'Maldivler' },
  { code: 'ML', en: 'Mali', de: 'Mali', tr: 'Mali' },
  { code: 'MT', en: 'Malta', de: 'Malta', tr: 'Malta' },
  { code: 'MH', en: 'Marshall Islands', de: 'Marshallinseln', tr: 'Marshall Adaları' },
  { code: 'MR', en: 'Mauritania', de: 'Mauretanien', tr: 'Moritanya' },
  { code: 'MU', en: 'Mauritius', de: 'Mauritius', tr: 'Mauritius' },
  { code: 'MX', en: 'Mexico', de: 'Mexiko', tr: 'Meksika' },
  { code: 'FM', en: 'Micronesia', de: 'Mikronesien', tr: 'Mikronezya' },
  { code: 'MD', en: 'Moldova', de: 'Moldau', tr: 'Moldova' },
  { code: 'MC', en: 'Monaco', de: 'Monaco', tr: 'Monako' },
  { code: 'MN', en: 'Mongolia', de: 'Mongolei', tr: 'Moğolistan' },
  { code: 'ME', en: 'Montenegro', de: 'Montenegro', tr: 'Karadağ' },
  { code: 'MA', en: 'Morocco', de: 'Marokko', tr: 'Fas' },
  { code: 'MZ', en: 'Mozambique', de: 'Mosambik', tr: 'Mozambik' },
  { code: 'MM', en: 'Myanmar', de: 'Myanmar', tr: 'Myanmar' },
  { code: 'NA', en: 'Namibia', de: 'Namibia', tr: 'Namibya' },
  { code: 'NR', en: 'Nauru', de: 'Nauru', tr: 'Nauru' },
  { code: 'NP', en: 'Nepal', de: 'Nepal', tr: 'Nepal' },
  { code: 'NL', en: 'Netherlands', de: 'Niederlande', tr: 'Hollanda' },
  { code: 'NZ', en: 'New Zealand', de: 'Neuseeland', tr: 'Yeni Zelanda' },
  { code: 'NI', en: 'Nicaragua', de: 'Nicaragua', tr: 'Nikaragua' },
  { code: 'NE', en: 'Niger', de: 'Niger', tr: 'Nijer' },
  { code: 'NG', en: 'Nigeria', de: 'Nigeria', tr: 'Nijerya' },
  { code: 'MK', en: 'North Macedonia', de: 'Nordmazedonien', tr: 'Kuzey Makedonya' },
  { code: 'NO', en: 'Norway', de: 'Norwegen', tr: 'Norveç' },
  { code: 'OM', en: 'Oman', de: 'Oman', tr: 'Umman' },
  { code: 'PK', en: 'Pakistan', de: 'Pakistan', tr: 'Pakistan' },
  { code: 'PW', en: 'Palau', de: 'Palau', tr: 'Palau' },
  { code: 'PA', en: 'Panama', de: 'Panama', tr: 'Panama' },
  { code: 'PG', en: 'Papua New Guinea', de: 'Papua-Neuguinea', tr: 'Papua Yeni Gine' },
  { code: 'PY', en: 'Paraguay', de: 'Paraguay', tr: 'Paraguay' },
  { code: 'PE', en: 'Peru', de: 'Peru', tr: 'Peru' },
  { code: 'PH', en: 'Philippines', de: 'Philippinen', tr: 'Filipinler' },
  { code: 'PL', en: 'Poland', de: 'Polen', tr: 'Polonya' },
  { code: 'PT', en: 'Portugal', de: 'Portugal', tr: 'Portekiz' },
  { code: 'QA', en: 'Qatar', de: 'Katar', tr: 'Katar' },
  { code: 'RO', en: 'Romania', de: 'Rumänien', tr: 'Romanya' },
  { code: 'RU', en: 'Russia', de: 'Russland', tr: 'Rusya' },
  { code: 'RW', en: 'Rwanda', de: 'Ruanda', tr: 'Ruanda' },
  { code: 'KN', en: 'Saint Kitts and Nevis', de: 'St. Kitts und Nevis', tr: 'Saint Kitts ve Nevis' },
  { code: 'LC', en: 'Saint Lucia', de: 'St. Lucia', tr: 'Saint Lucia' },
  { code: 'VC', en: 'Saint Vincent and the Grenadines', de: 'St. Vincent und die Grenadinen', tr: 'Saint Vincent ve Grenadinler' },
  { code: 'WS', en: 'Samoa', de: 'Samoa', tr: 'Samoa' },
  { code: 'SM', en: 'San Marino', de: 'San Marino', tr: 'San Marino' },
  { code: 'ST', en: 'São Tomé and Príncipe', de: 'São Tomé und Príncipe', tr: 'São Tomé ve Príncipe' },
  { code: 'SA', en: 'Saudi Arabia', de: 'Saudi-Arabien', tr: 'Suudi Arabistan' },
  { code: 'SN', en: 'Senegal', de: 'Senegal', tr: 'Senegal' },
  { code: 'RS', en: 'Serbia', de: 'Serbien', tr: 'Sırbistan' },
  { code: 'SC', en: 'Seychelles', de: 'Seychellen', tr: 'Seyşeller' },
  { code: 'SL', en: 'Sierra Leone', de: 'Sierra Leone', tr: 'Sierra Leone' },
  { code: 'SG', en: 'Singapore', de: 'Singapur', tr: 'Singapur' },
  { code: 'SK', en: 'Slovakia', de: 'Slowakei', tr: 'Slovakya' },
  { code: 'SI', en: 'Slovenia', de: 'Slowenien', tr: 'Slovenya' },
  { code: 'SB', en: 'Solomon Islands', de: 'Salomonen', tr: 'Solomon Adaları' },
  { code: 'SO', en: 'Somalia', de: 'Somalia', tr: 'Somali' },
  { code: 'ZA', en: 'South Africa', de: 'Südafrika', tr: 'Güney Afrika' },
  { code: 'SS', en: 'South Sudan', de: 'Südsudan', tr: 'Güney Sudan' },
  { code: 'ES', en: 'Spain', de: 'Spanien', tr: 'İspanya' },
  { code: 'LK', en: 'Sri Lanka', de: 'Sri Lanka', tr: 'Sri Lanka' },
  { code: 'SD', en: 'Sudan', de: 'Sudan', tr: 'Sudan' },
  { code: 'SR', en: 'Suriname', de: 'Suriname', tr: 'Surinam' },
  { code: 'SE', en: 'Sweden', de: 'Schweden', tr: 'İsveç' },
  { code: 'CH', en: 'Switzerland', de: 'Schweiz', tr: 'İsviçre' },
  { code: 'SY', en: 'Syria', de: 'Syrien', tr: 'Suriye' },
  { code: 'TW', en: 'Taiwan', de: 'Taiwan', tr: 'Tayvan' },
  { code: 'TJ', en: 'Tajikistan', de: 'Tadschikistan', tr: 'Tacikistan' },
  { code: 'TZ', en: 'Tanzania', de: 'Tansania', tr: 'Tanzanya' },
  { code: 'TH', en: 'Thailand', de: 'Thailand', tr: 'Tayland' },
  { code: 'TL', en: 'Timor-Leste', de: 'Osttimor', tr: 'Doğu Timor' },
  { code: 'TG', en: 'Togo', de: 'Togo', tr: 'Togo' },
  { code: 'TO', en: 'Tonga', de: 'Tonga', tr: 'Tonga' },
  { code: 'TT', en: 'Trinidad and Tobago', de: 'Trinidad und Tobago', tr: 'Trinidad ve Tobago' },
  { code: 'TN', en: 'Tunisia', de: 'Tunesien', tr: 'Tunus' },
  { code: 'TR', en: 'Turkey', de: 'Türkei', tr: 'Türkiye' },
  { code: 'TM', en: 'Turkmenistan', de: 'Turkmenistan', tr: 'Türkmenistan' },
  { code: 'TV', en: 'Tuvalu', de: 'Tuvalu', tr: 'Tuvalu' },
  { code: 'UG', en: 'Uganda', de: 'Uganda', tr: 'Uganda' },
  { code: 'UA', en: 'Ukraine', de: 'Ukraine', tr: 'Ukrayna' },
  { code: 'AE', en: 'United Arab Emirates', de: 'Vereinigte Arabische Emirate', tr: 'Birleşik Arap Emirlikleri' },
  { code: 'GB', en: 'United Kingdom', de: 'Vereinigtes Königreich', tr: 'Birleşik Krallık' },
  { code: 'US', en: 'United States', de: 'Vereinigte Staaten', tr: 'Amerika Birleşik Devletleri' },
  { code: 'UY', en: 'Uruguay', de: 'Uruguay', tr: 'Uruguay' },
  { code: 'UZ', en: 'Uzbekistan', de: 'Usbekistan', tr: 'Özbekistan' },
  { code: 'VU', en: 'Vanuatu', de: 'Vanuatu', tr: 'Vanuatu' },
  { code: 'VA', en: 'Vatican City', de: 'Vatikanstadt', tr: 'Vatikan' },
  { code: 'VE', en: 'Venezuela', de: 'Venezuela', tr: 'Venezuela' },
  { code: 'VN', en: 'Vietnam', de: 'Vietnam', tr: 'Vietnam' },
  { code: 'YE', en: 'Yemen', de: 'Jemen', tr: 'Yemen' },
  { code: 'ZM', en: 'Zambia', de: 'Sambia', tr: 'Zambiya' },
  { code: 'ZW', en: 'Zimbabwe', de: 'Simbabwe', tr: 'Zimbabve' },
];

/**
 * Get countries sorted alphabetically by the specified language's name
 */
export function getSortedCountries(lang: 'en' | 'de' | 'tr'): Country[] {
  return [...COUNTRIES].sort((a, b) => {
    const nameA = a[lang].toLowerCase();
    const nameB = b[lang].toLowerCase();
    return nameA.localeCompare(nameB, lang === 'tr' ? 'tr' : lang === 'de' ? 'de' : 'en');
  });
}

/**
 * Get localized country name from ISO code
 * Returns empty string if code not found
 */
export function getCountryName(code: string, lang: 'en' | 'de' | 'tr'): string {
  if (!code) return '';
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country[lang] : '';
}

